import {createContext, useContext} from 'react'

import type {EufePageFragment} from '@sdox/api'

interface PageContextState {
  page: EufePageFragment
}

export const PageContext = createContext<PageContextState | undefined>(undefined)

export const usePage = () => {
  const value = useContext(PageContext)
  if (value === undefined) {
    throw new Error('PageContext must be defined')
  }
  return value.page
}

export const usePageId = () => {
  const value = useContext(PageContext)
  if (value === undefined) {
    throw new Error('PageContext must be defined')
  }
  return value.page.id
}
